import { render } from "./SingleGeneric.vue?vue&type=template&id=e9789fc0"
import script from "./SingleGeneric.vue?vue&type=script&lang=js"
export * from "./SingleGeneric.vue?vue&type=script&lang=js"
script.render = render

export default script